module.exports = __webpack_public_path__ + "img/green-arrow.a2b679ad.svg";